// extracted by mini-css-extract-plugin
export default {"svg":"ExclamationIcon_svg__pR9cF","active":"ExclamationIcon_active__qCh60"};